import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NavLink } from "react-router-dom";
import DataView from 'Components/DataView';

//Actions
import { maintenanceWarningsDetailsRequest, clearRedux } from 'Redux/actions';
import { useEffect, useRef, useState } from "react";

//Styles
import './index.scss';
const MaintenanceWarningsDetails = (props) => {

    const { messages } = useIntl();
    const dispatch = useDispatch();
    const tableRef = useRef(null)

    //Redux States
    const { openModal, loading, data, result } = useSelector(state => state.maintenanceWarningsDetailsRedux);

    //Local States
    const [columns, setColumns] = useState([
        {
            key: "date",
            title: messages['lastreadings_details_date'],
            width: 150,
            show: true,
            code: 'lastreadings_details_date',
            export: true,
            exportValue: (item) => {
                return data?.date;
            },
            render: () => {
                return (
                    <span>{data?.date}</span>
                )
            }
        },
        {
            key: "companyName",
            title: messages['lastreadings_details_account_name'],
            width: 250,
            show: true,
            code: 'lastreadings_details_account_name',
            export: true,
            exportCell: "companyName",
            functionString: "return row?.companyName",
            render: (item) => {
                return (
                    <NavLink to={`/app/accounts/overview/${item?.companyId}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.companyName}</span>
                    </NavLink>
                )
            }
        },
        {
            key: "label",
            title: messages['lastreadings_details_device_name'],
            width: 250,
            show: true,
            code: 'lastreadings_details_device_name',
            export: true,
            exportCell: "label",
            functionString: "return row?.label",
            render: (item) => {
                return (
                    <span>{item?.label}</span>
                )
            }
        },
        {
            key: "manufacturerName",
            title: messages['lastreadings_details_manufacturer'],
            width: 150,
            show: true,
            code: 'lastreadings_details_manufacturer',
            export: true,
            exportCell: "manufacturerName",
            functionString: "return row?.manufacturerName",
            render: (item) => {
                return (
                    <span >{item?.manufacturerName}</span>
                )
            }
        },
        {
            key: "esn",
            title: messages['lastreadings_details_device_id'],
            width: 150,
            show: true,
            code: 'lastreadings_details_device_id',
            export: true,
            exportCell: "esn",
            functionString: "return row?.esn",
            render: (item) => {
                return (
                    <NavLink to={`/app/devices/overview/${item?.unitId}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.esn}</span>
                    </NavLink>
                )
            }
        },
        {
            key: "warning",
            title: messages['lastreadings_details_warning'],
            width: 150,
            show: true,
            code: 'lastreadings_details_warning',
            export: true,
            exportCell: "warning",
            functionString: "return row?.warning",
            render: (item) => {
                return (
                    <span>{item?.warning}</span>
                )
            }
        },
    ])

    const closeModal = () => {
        dispatch(clearRedux("MAINTENANCE_WARNINGS_DETAILS"))
    }

    useEffect(() => {
        if (openModal) {
            let payload = {
                id: data?.gadgetId,
                query: {
                    level: 1,
                    gadgetParams: JSON.stringify({
                        date: data?.date,
                        label: data?.label
                    })
                }
            }
            dispatch(maintenanceWarningsDetailsRequest(payload, true))
        }
        return () => {
            dispatch(clearRedux("MAINTENANCE_WARNINGS_DETAILS"))
        }
    }, [data])

    return (
        <Modal
            open={openModal}
            title={`${data?.label || ''} ${result?.total ? `(${result?.total})` : ""}`}
            handleClose={() => closeModal()}
            position="right"
            size="small"
            loading={loading}
        >
            <ModalBody>
                <div className="maintenance-warning-table">
                    <DataView
                        ref={tableRef}
                        tableButtons={["export"]}
                        name="maintenance-warnings"
                        exportName="maintenancewarnings"
                        dataGridExport
                        columns={columns || []}
                        externalData={result?.items?.length ? result?.items.map((item) => ({ ...item, companyName: item?.companyName?.replace(/,/g, '.') })) : []}
                        topheight={230}
                        noSplit
                        noSearch
                        noFilters
                        disableItemSelection
                        noRefresh
                        noDensity
                        externalDataTotal={result?.total}
                        onChangeColumns={(items) => setColumns(items)}
                        noPreferences
                        nextToken={result?.total}
                        infiniteScroll
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Button
                        className="btn-dark-blue"
                        onClick={() => closeModal()}
                    >
                        {messages['common_close']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default MaintenanceWarningsDetails